import { combineReducers } from 'redux';

import { reducer as availableAssets } from './availableAssetsModule';

export default combineReducers({ availableAssets });
